import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  H5,
  HTMLSelect,
  InputGroup,
  Popover,
  Switch,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { api_adm } from "../../api";
import { AppStore } from "../../stores/AppStore";
import { CalcStore } from "../../stores/calculo/CalcStore";
import { toast } from "react-toastify";
import {
  MDBBtn,
  MDBCol,
  MDBRow,
} from "mdbreact";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField
} from "react-bootstrap-table";
import { AppIcon } from "../utils/AppIcon";
import InfoModal from "../info-modal/InfoModal";

interface Props {
}

interface State {
  listCalcs: any[];
  listIdsClass: any[];
}

@observer
export class CalcsClassificacaoPage extends React.Component<Props, State> {

  obs = observable({
    modalEditClassificacao: false as boolean,
    codigo_receita: "" as string,
    nome_classificacao: "" as string,
    id_classificacao: "" as string,
    dae_avulso: false as boolean,
    dei: false as boolean,
    codigo_ajuste: "" as string,
    open_ajuda: false as boolean,
    cod_or: "" as string,
    open_select_calcs: false as boolean,
    open_select_class: false as boolean,
    apuracao_saida: false as boolean,
    texto_ajuda: "" as string,
  })

  constructor(props) {
    super(props);

    this.state = {
      listCalcs: [],
      listIdsClass: []
    }

  }

  async componentDidMount() {
    AppStore.setTitle("Formas de Cálculo");

    await CalcStore.handldeBuscaClassificacao();

  }

  async handleDelete(classificacao) {

    try {

      let params = {
        id: classificacao.id,
        estado: "PA"
      }

      let resp = await api_adm.post(`/api/admin/icms_classificacoes/delete`, params);

      if (resp.data.ok) {

        toast.success('Classificação excluída!', {});

        await CalcStore.handldeBuscaClassificacao();

      } else {

        toast.error(`Classificação não pôde ser excluído: ${resp.data.msg}`, {})

      }

    } catch (ex) {

      toast.error('Erro ao excluir Classificação!', {})
    }

  }

  async handleEdit(classificacao) {

    await CalcStore.handleCalcs();

    this.obs.codigo_receita = classificacao.codigo_receita;
    this.obs.nome_classificacao = classificacao.nome;
    this.obs.codigo_ajuste = classificacao.codigo_ajuste || "";
    this.obs.cod_or = classificacao.cod_or || "";
    this.obs.dae_avulso = classificacao.dae_avulso || false;
    this.obs.id_classificacao = classificacao.id;
    this.obs.apuracao_saida = classificacao.apuracao_saida || false;
    this.obs.dei = classificacao.dei || false;

    this.setState({
      listCalcs: (classificacao.ids_calc_credito_entrada || []),
      listIdsClass: (classificacao.ids_cassificacao_self || [])
    })

    this.obs.modalEditClassificacao = true;

  }

  handleSaveClassificacao = async () => {
    if (!this.obs.nome_classificacao) {
      toast.error('Preencha o nome da classificação', {});
      return;
    }

    if (!this.obs.codigo_receita) {
      toast.error('Preencha o código da receita', {});
      return;
    }

    let params = {
      id: this.obs.id_classificacao,
      codigo_receita: this.obs.codigo_receita,
      nome: this.obs.nome_classificacao,
      codigo_ajuste: this.obs.codigo_ajuste,
      dae_avulso: this.obs.dae_avulso,
      dei: this.obs.dei,
      estado: "PA",
      ids_calc_credito_entrada: this.state.listCalcs,
      cod_or: this.obs.cod_or ? this.obs.cod_or : null,
      apuracao_saida: this.obs.apuracao_saida,
      ids_cassificacao_self: this.state.listIdsClass,
    };

    let resp = await CalcStore.updateClassificacao(params)

    if (resp) {

      await CalcStore.handldeBuscaClassificacao();

      this.obs.modalEditClassificacao = false;

    }

  };

  renderShowsTotal(start, to, total) {
    return (
      <p style={{ marginLeft: 12 }}>
        Mostrando {start} a {to} de {total} resultados.&nbsp;&nbsp;
      </p>
    );
  }

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Código, nome)"
      />
    );
  };

  createCustomSearchFieldSol = (props) => {
    return (
      <SearchField
        className="input-filter input-filter-sefa input-filter-calcs"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Nome)"
      />
    );
  };

  handleCheckCalcs = async (row, checked) => {

    if (checked) {

      this.setState(state => { state.listCalcs.push(row.id) });

    } else {

      let index = this.state.listCalcs.indexOf(row.id);

      this.state.listCalcs.splice(index, 1);

    }

  };

  handleCheckCalcsAll = async (check, row) => {

    if (check) {

      this.setState({ listCalcs: row?.map(value => value.id) });

    } else {

      this.setState({ listCalcs: [] });
    }

  };

  handleCheckClass = async (row, checked) => {

    if (checked) {

      this.setState(state => { state.listIdsClass.push(row.id) });

    } else {

      let index = this.state.listIdsClass.indexOf(row.id);

      this.state.listIdsClass.splice(index, 1);

    }

  };

  handleCheckClassAll = async (check, row) => {

    if (check) {

      this.setState({ listIdsClass: row?.map(value => value.id) });

    } else {

      this.setState({ listIdsClass: [] });
    }

  };

  render() {

    const options = {
      page: 1,
      sizePerPageList: [{
        text: "20",
        value: 20,
      }, {
        text: "50",
        value: 50,
      }, {
        text: "100",
        value: 100,
      }],
      sizePerPage: 50,
      pageStartIndex: 1,
      paginationSize: 4,
      prePage: "Ante",
      nextPage: "Próxima",
      firstPage: "Início",
      lastPage: "Última",
      paginationShowsTotal: this.renderShowsTotal,
      paginationPosition: "bottom",
      searchField: this.createCustomSearchField
    };

    const optionsClass = {
      searchField: this.createCustomSearchFieldSol,
    };

    const buttonFormatter = (cell, row) => {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={() => this.handleEdit(row)}
          >
            <img src="/images/edit.png" width={25} />
          </MDBBtn>

          <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
            <MDBBtn color="default" rounded size="sm">
              <img src="/images/bin.png" width={25} />
            </MDBBtn>
            <div>
              <H5>Confirmar exclusão?</H5>
              <p>Confirmar exclusão da classificação?</p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 15,
                }}
              >
                <Button
                  className={Classes.POPOVER_DISMISS}
                  style={{ marginRight: 10 }}
                >
                  Cancelar
                </Button>
                <Button
                  intent="danger"
                  className={Classes.POPOVER_DISMISS}
                  onClick={() => this.handleDelete(row)}
                >
                  Excluir
                </Button>
              </div>
            </div>
          </Popover>
        </>
      );
    }

    const selectRowCalcs = {
      mode: "checkbox",
      clickToSelect: true,
      columnWidth: "40px",
      onSelect: this.handleCheckCalcs,
      onSelectAll: this.handleCheckCalcsAll,
      selected: this.state.listCalcs,
    };

    let calcs = CalcStore.obs.calcs_class?.map(obj => {

      return ({
        id: (obj.id || obj._id),
        nome: obj.nome,
      })

    });

    const selectRowClass = {
      mode: "checkbox",
      clickToSelect: true,
      columnWidth: "40px",
      onSelect: this.handleCheckClass,
      onSelectAll: this.handleCheckClassAll,
      selected: this.state.listIdsClass,
    };

    let classificacoes = CalcStore.obs.itens_classificacao?.map(obj => {

      return ({
        id: (obj.id || obj._id),
        nome: obj.nome,
      })

    });

    return (
      <div>

        <BootstrapTable className="TableDefault" data={CalcStore.obs.itens_classificacao} options={options} pagination search>
          <TableHeaderColumn dataField='id' isKey={true} hidden width='1%'>#</TableHeaderColumn>
          <TableHeaderColumn dataField='codigo_receita' width='15%'>Código Receita</TableHeaderColumn>
          <TableHeaderColumn dataField='nome' width='70%'>Nome</TableHeaderColumn>
          <TableHeaderColumn dataField='codigo_ajuste' width='15%'>Código Ajuste</TableHeaderColumn>
          <TableHeaderColumn dataFormat={buttonFormatter} width='20%'></TableHeaderColumn>
        </BootstrapTable>

        <Dialog
          isOpen={this.obs.modalEditClassificacao}
          onClose={() => this.obs.modalEditClassificacao = false}
          title="Editar Classificação"
          className="AlertUser modalSefa"
        >
          <div className={Classes.DIALOG_BODY}>
            <div style={{ marginBottom: 10 }} className="AlertImportacoes">
              <MDBRow>
                <MDBCol>
                  <FormGroup label="Código Receita" labelFor="codigo-receita" style={{ width: 300 }}>
                    <InputGroup
                      id="codigo-receita"
                      value={this.obs.codigo_receita}
                      onChange={(e: any) => this.obs.codigo_receita = e.target.value}
                    />
                  </FormGroup>
                </MDBCol>
                <MDBCol>
                  <FormGroup label="Código Ajuste" labelFor="codigo-ajuste" style={{ width: 300 }}>
                    <InputGroup
                      id="codigo-ajuste"
                      value={this.obs.codigo_ajuste}
                      onChange={(e: any) => this.obs.codigo_ajuste = e.target.value}
                    />
                  </FormGroup>
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol size="6">
                  <FormGroup label="Nome" labelFor="nome">
                    <InputGroup
                      id="nome"
                      value={this.obs.nome_classificacao}
                      onChange={(e: any) => this.obs.nome_classificacao = e.target.value}
                    />
                  </FormGroup>
                </MDBCol>
                <MDBCol size="6">
                  <FormGroup label="Código do ICMS recolhido ou a recolher" style={{ width: 300 }}>
                    <HTMLSelect
                      onChange={(e) => this.obs.cod_or = e.target.value}
                      value={this.obs.cod_or}
                    >
                      <option value="">Selecione</option>
                      <option value="090">090 - Outras obrigações do ICMS</option>
                      <option value="000">000 - ICMS a recolher</option>
                      <option value="005">005 - Antecipação tributária</option>
                    </HTMLSelect>
                  </FormGroup>
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol size="4">
                  <FormGroup label="DEI">
                    <Switch
                      label={this.obs.dei ? "Sim" : "Não"}
                      checked={this.obs.dei}
                      onChange={(e: any) => this.obs.dei = e.target.checked}
                    />
                  </FormGroup>
                </MDBCol>
                <MDBCol size="4">
                  <FormGroup label="DAE Avulso">
                    <Switch
                      label={this.obs.dae_avulso ? "Sim" : "Não"}
                      checked={this.obs.dae_avulso}
                      onChange={(e: any) => this.obs.dae_avulso = e.target.checked}
                    />
                  </FormGroup>
                </MDBCol>
                <MDBCol size="4">
                  <FormGroup label="Apuração Saída">
                    <Switch
                      label={this.obs.apuracao_saida ? "Sim" : "Não"}
                      checked={this.obs.apuracao_saida}
                      onChange={(e: any) => this.obs.apuracao_saida = e.target.checked}
                    />
                  </FormGroup>
                </MDBCol>
              </MDBRow>

              <span><b style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => this.obs.open_select_calcs = true}>{"Selecione os Cálculos >> "}</b>
                <AppIcon name="help" className="pulse-notification-pgdas" color="blue" style={{ cursor: "pointer", marginLeft: 5 }} onClick={() => {
                  this.obs.texto_ajuda = "Cálculos vinculados ao crédito pela entrada: se você estiver apurando a saída, o sistema buscará cada classificação da saída correspondente na entrada, apenas para os cálculos que você selecionar aqui."
                  this.obs.open_ajuda = true
                }} />
              </span>

              <br />
              <br />

              {this.obs.apuracao_saida
                ? <span><b style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => this.obs.open_select_class = true}>{"Selecione as Classificações >> "}</b>
                  <AppIcon name="help" className="pulse-notification-pgdas" color="blue" style={{ cursor: "pointer", marginLeft: 5 }} onClick={() => {
                    this.obs.texto_ajuda = "As classificações selecionadas serão agrupadas nesta nova que está sendo criada. Exemplo: ao criar a classificação X vinculando as classificações Y e Z, na apuração de saída aparecerá apenas a classificação (imposto) X."
                    this.obs.open_ajuda = true
                  }} />
                </span>

                : <></>
              }

            </div>
          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" onClick={() => this.obs.modalEditClassificacao = false} />
              <Button text="Salvar" intent="primary" onClick={this.handleSaveClassificacao} />
            </div>
          </div>

        </Dialog>

        <Dialog
          isOpen={this.obs.open_select_calcs}
          onClose={() => this.obs.open_select_calcs = false}
          title="Cálculos"
        >
          <div className={Classes.DIALOG_BODY}>

            <div className="select-empresa-sefa select-calcs">
              <BootstrapTable data={calcs} selectRow={selectRowCalcs} options={optionsClass} search>
                <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                <TableHeaderColumn dataField="nome" width="90%">Nome</TableHeaderColumn>
              </BootstrapTable>
            </div>

          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => this.obs.open_select_calcs = false} />
            </div>
          </div>
        </Dialog>

        <Dialog
          isOpen={this.obs.open_select_class}
          onClose={() => this.obs.open_select_class = false}
          title="Classificações"
        >
          <div className={Classes.DIALOG_BODY}>
            <div className="select-empresa-sefa select-calcs">
              <BootstrapTable data={classificacoes} selectRow={selectRowClass} options={optionsClass} search>
                <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                <TableHeaderColumn dataField="nome" width="90%">Nome</TableHeaderColumn>
              </BootstrapTable>
            </div>
          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => this.obs.open_select_class = false} />
            </div>
          </div>
        </Dialog>

        <InfoModal open={this.obs.open_ajuda} onClose={() => this.obs.open_ajuda = false} texto_info={this.obs.texto_ajuda} />

      </div>
    );
  }
}

export default CalcsClassificacaoPage;